<template>
  <div class="hair-rituel__wrapper">
    <!-- <picture class="c-text-image__visual-container">
      <source media="(min-width: 768px)" srcset="../assets/imgs/offers/2020w09-hr-top.jpg, ../assets/imgs/offers/2020w09-hr-top.jpg 2x">
      <source media="(min-width: 0)" srcset="../assets/imgs/offers/2020w09-hr-top-mobile.jpg, ../assets/imgs/offers/2020w09-hr-top-mobile.jpg 2x">
      <img class="image--full-width image--fit lazyloaded" alt="Hair rituel by Sisley" srcset="../assets/imgs/offers/2020w01-hr-top.jpg 2x" src="../assets/imgs/offers/2020w01-hr-top.jpg">
    </picture> -->
    <!-- <Breadcrumb :config="{}" /> -->
    <template v-if="nodes && nodes.length">
      <component v-for="(node, index) in nodes" :key="index" :is="node.tag" :config="node"></component>
    </template>
  </div>
</template>

<script>
import api from "@/utils/api";
import types from "@/store/types";
import utils from "@/utils";

export default {
  name: 'HairRituel',
  components: {
    Breadcrumb: () => import('@/components/Breadcrumb'),
    // 文本和图标组件
    IconTitle: () => import('@/components/IconTitle'),
    IconTitleYellow: () => import('@/components/IconTitleYellow'),
    Txt: () => import('@/components/BigText'),
    TxtSimple: () => import('@/components/TxtSimple'),
    MultiLineText: () => import('@/components/MultiLineText'),
    BlankSpace: () => import('@/components/BlankSpace'),
    // 图片组件
    XImage: () => import('@/components/XImage'),
    BannerImage: () => import('@/components/ImageBanner'),
    Image2text: () => import('@/components/Image2text'),
    MultiImageProduct: () => import('@/components/MultiImageProduct'),
    MultiImageProductHigh: () => import('@/components/MultiImageProductHigh'),
    MultiImageIcon: () => import('@/components/MultiImageIcon'),
    ImageFlex: () => import('@/components/ImageFlex'),
    ImageFlexHair: () => import('@/components/ImageFlexHair'),
    ImageFlexRight: () => import('@/components/ImageFlexRight'),
    ImageFlexImage: () => import('@/components/ImageFlexImage'),
    ImageFlexSimple: () => import('@/components/ImageFlexSimple'),
    ImageFlexUnlimited: () => import('@/components/ImageFlexUnlimited'),
    MultiImage: () => import('@/components/MultiImage'),
    VideoHome: () => import('@/components/VideoHome'),
    XVideo: () => import('@/components/XVideo'),
    // 轮播组件
    Swiper: () => import('@/components/Swiper'),
    BaseSwiper: () => import('@/components/BaseSwiper'),
    MultiImageProductSwiper: () => import('@/components/MultiImageProductSwiper'),
    ProductSwiper: () => import('@/components/ProductSwiper'),
    ImageOnTextSwiper: () => import('@/components/ImageOnTextSwiper'),
    XSwiper: () => import('@/components/XSwiper'),
    // 动画组件
    InTextAnimate: () => import('@/components/InTextAnimate'),
    InTextAnimateMiddle: () => import('@/components/InTextAnimateMiddle'),
    InVideoAnimate: () => import('@/components/InVideoAnimate'),
    // 商品组件
    CategoryList: () => import('@/components/CategoryList'),
    // 其他组件
    OfflineAppointmentPc: () => import('@/components/OfflineAppointmentPc'),
    OfflineAppointmentWechat: () => import('@/components/DefaultPlugin'),
    AnchorPoint: () => import('@/components/AnchorPoint')
  },
  data() {
    return {
      nodes: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      api.ajax4Page(types.$PAGE_HOME_SECONDARY).then(res => {
        let { nodes, title, desciption, keyword } = res;
        let key = types.$PAGE_HOME_SECONDARY
        // 页面信息处理
        title && utils.setPageInfo(`${title}`, {
          keywords: keyword || [title, key].join(","),
          description: desciption || title
        });  
        if (Array.isArray(nodes) && nodes.length) {
          this.nodes = nodes;
        } else {
          this.$message({ message: "页面配置错误", iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  }
}
</script>


<style lang="scss" scoped>
.hair-rituel__wrapper {
  box-sizing: border-box;
}
</style>